/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import i18n from 'i18n';
import {
  FormTemplate,
  FormTemplateOption,
  FormTemplateSection,
} from 'data/template/template.types';
import { AccessFunction } from 'data/accessFunction/accessFunction.types';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.NAME.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function getLeaOptions(
  afName: string,
  accessFunctions: AccessFunction[],
): FormTemplateOption[] {
  const filteredAf = accessFunctions
    .filter((accessFunction) => (accessFunction.name === afName));

  let afLeas: string[] | [] = [];

  if (filteredAf.length) {
    afLeas = filteredAf[0]?.dataInterfaces?.map((dataInterface) => {
      const filteredLea = dataInterface.options.filter((option) => {
        return option.key === 'lea';
      });
      return filteredLea[0].value;
    }) as string[];
  }

  return [
    {
      label: i18n.t('common.form.selectValue'),
      value: '',
    },
    ...afLeas.map((afLea) => {
      return {
        label: afLea as string,
        value: afLea as string,
      };
    }),
  ];
}
